
import { useAllUserPresence } from "./AllUsersPresenceProvider";

export const useUserStatus = (userId) => {
    const all = useAllUserPresence();
    const online = all?.has(userId) ? "online" : "offline";

    return { online };
};
